import { OpusEvent, Parameters } from './models';

export interface PackedEvent { event: OpusEvent; row: number; }
export interface PackedRun { visible: PackedEvent[]; overflow: OpusEvent[]; rows: number; }
export interface ParameterPreview { text: string; truncated: boolean; omittedValues: number; }

const end = (event: OpusEvent) => event.planningDurationS === null ? event.planningStartS + .1 : Math.max(event.planningEndS, event.planningStartS + .1);

export function packOverlappingEvents(events: OpusEvent[], maxRows = 4): PackedEvent[] {
  const rowEnds = Array.from({ length: maxRows }, () => -Infinity);
  return [...events].sort((a, b) => a.planningStartS - b.planningStartS || end(a) - end(b) || a.eventId.localeCompare(b.eventId)).map(event => {
    const row = rowEnds.findIndex(rowEnd => rowEnd <= event.planningStartS);
    const assigned = row < 0 ? maxRows - 1 : row;
    rowEnds[assigned] = Math.max(rowEnds[assigned], end(event));
    return { event, row: assigned };
  });
}

export function packRunEvents(events: OpusEvent[], maxRows = 8): PackedRun {
  const rowEnds = Array.from({ length: maxRows }, () => -Infinity);
  const visible: PackedEvent[] = []; const overflow: OpusEvent[] = [];
  [...events].sort((a, b) => a.planningStartS - b.planningStartS || end(a) - end(b) || a.eventId.localeCompare(b.eventId)).forEach(event => {
    const row = rowEnds.findIndex(rowEnd => rowEnd <= event.planningStartS);
    if (row < 0) { overflow.push(event); return; }
    rowEnds[row] = end(event); visible.push({ event, row });
  });
  return { visible, overflow, rows: Math.max(1, ...visible.map(item => item.row + 1)) };
}

export function blockingLabel(event: OpusEvent): string {
  return event.holdsSequence ? 'Blocking — advances the sequence' : 'Non-blocking — may run in parallel';
}

export function parameterPreview(parameters: Parameters, maxCharacters = 180, maxValues = 8): ParameterPreview {
  let omittedValues = 0;
  const text = Object.entries(parameters).map(([key, value]) => {
    const values = value.split(',');
    if (values.length > maxValues) { omittedValues += values.length - maxValues; return `${key}=${values.slice(0, maxValues).join(',')}…`; }
    return `${key}=${value}`;
  }).join('; ');
  if (text.length <= maxCharacters) return { text, truncated: omittedValues > 0, omittedValues };
  return { text: `${text.slice(0, maxCharacters).trimEnd()}…`, truncated: true, omittedValues };
}
